var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.visible)?_c('AskAIButton',{key:'ai_assistant_' + _vm.$route.name,attrs:{"modal-id":_vm.modalId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }